export default "__VITE_ASSET__CACC30Qf__"